var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',_vm._g(_vm._b({staticClass:"keep-signed-in"},'b-form-checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.$t('label'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }